import { ActionType, ProColumns } from '@ant-design/pro-components';
import { Form, InputNumber, Modal, Radio, message } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { ROUTES } from 'base/routes/routes';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import { CheckStatus, CloseStatus, Download } from 'base/ui/components/Icons';
import useDebounce from 'hooks/useDebounce';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CommonModel, ProductModel } from 'services/Main/common_services';
import { commonPresenter, commonStore, warrantyRemindPresenter, warrantyRemindStore } from 'stores/root_store';
import { SYSTEM_TITLE } from 'utils/constants';
import { getPlantCode } from 'utils/localStorageHelper';
import ReminderModal from './Modal';



export const normalizeString = (value: string): string => {
  return value
    ?.normalize('NFD') // decompose combined graphemes into the combination of simple ones
    .replace(/[\u0300-\u036f]/g, '') // remove accents
    .replace(/[đĐ]/g, (m) => (m === 'đ' ? 'd' : 'D')); // convert "đ/Đ" to "d/D"
};


// Thêm mới cấu hình thời gian nhắc nhở bảo hành =================================================================
const createAddUpdate = () => {
  return observer(() => {

    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();

    const [searchParams] = useSearchParams();
    const warrantyReminderId = searchParams.get("contentId");


    const [form] = Form.useForm();
    const navigate = useNavigate();
    // =================================================================================================
    const remindConfigType = useWatch('remindConfigType', form)
    const congTy = useWatch('companyCode', form)

    let pageTitle = "";

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (warrantyReminderId) {
      // Kiểm tra phân quyền
      // useCheckPermission("EDIT");
      pageTitle = t("page-title.edit-page");
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      // useCheckPermission("CREATE");
      pageTitle = t("page-title.add-page");
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    }

    const defaultColumn: ProColumns[] = [
      {
        title: 'STT',
        // dataIndex: 'stt',
        valueType: 'index',
        fixed: true,
        width: 50,
        align: 'center',
      },
      {
        title: 'Phân loại vật tư',
        dataIndex: 'phanLoaiVatTuName',
        search: false,
      },
      {
        title: 'Nhóm vật tư',
        dataIndex: 'nhomVatTuName',
        search: false,
      },
      {
        title: 'Mã SAP',
        dataIndex: 'sapCode',
        align: 'center',
      },
      {
        title: 'Mã thương mại',
        dataIndex: 'productCode',
      },
      {
        title: 'Tên sản phẩm',
        dataIndex: 'productName',
        width: 300,
      },
      {
        title: 'Trạng thái sử dụng',
        dataIndex: 'actived',
        search: false,
        render: (_, record) =>
          record.actived ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
    ];

    const [open, setOpen] = useState(false);


    const tableRef = useRef<ActionType>();
    // ============================================ LẤY DROPDOWN ==========================================================
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [listProductId, setListProductId] = useState<any[]>([]);

    const [loading, setLoading] = usePartialState({
      btn: false,
      searchProduct: false
    });
    // lưu / lưu và tiếp tục
    const [isContinue, setContinue] = useState(false);
    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    const [listMateGroup, setListMateGroup] = useState<CommonModel[]>([]);
    const [listProduct, setListProduct] = useState<ProductModel[]>([]);
    const [listMateClass, setListMateClass] = useState<CommonModel[]>([]);

    const [listProductFiltered, setListProductFiltered] = useState<ProductModel[]>([]);

    // =================================================================================================================
    // =================================================================================================================
    // =================================================================================================================

    // =================================================================================================================
    // =================================================================================================================
    // =================================================================================================================
    // select row
    const onSelectChange = (newSelectedRowKeys: React.Key[], selectRows: ProductModel[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
      // console.log({ selectRows });
      setListProductId(selectRows.map(item => item.productId))
    };

    // Nhóm vật tự
    const getDataMateGroup = async (key?: string, list?: string[]) => {
      await commonPresenter.getListMaterialGroup(commonStore, {
        key: key,
        list: list
      });
      if (commonStore.commonRespone.isSuccess) {
        setListMateGroup(commonStore.commonRespone.data);
      }
    };
    const debounceSearchMateGroup = useDebounce(getDataMateGroup, 300)

    // Phân loại vật tư
    const getMateClass = async (key?: string, list?: string[]) => {
      await commonPresenter.getListMaterialClass(commonStore, {
        key: key,
        list: list
      });
      if (commonStore.commonRespone.isSuccess) {
        setListMateClass(commonStore.commonRespone.data);
      }
    };
    const debounceSearchMateClass = useDebounce(getMateClass, 300)

    // SHOW MODAL
    const showModal = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    }

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };
    // san pham
    const getDataSanPham = async (key?: string) => {
      const phanLoaiVT = form.getFieldValue('phanLoaiVatTuList')
      const nhomVatTuList = form.getFieldValue('nhomVatTuList')

      // mảng product id để hiển thị ra table
      const productIds = warrantyReminderId ? warrantyRemindStore.detailRemindRespone.data?.productList.map(item => item.productId) : undefined
      await commonPresenter.getListProduct(commonStore, {
        key: key,
        list: productIds,
        companyCode: congTy,
        phanloatvattulist: phanLoaiVT,
        nhomvattulist: nhomVatTuList,
      });
      if (commonStore.commonRespone.isSuccess) {
        setListProduct(commonStore.productData.data);
      }
    };

    // lấy chi tiết remind
    const getDetailData = async () => {
      if (warrantyReminderId) {
        await warrantyRemindPresenter.detailWarrantyRemind(warrantyRemindStore, warrantyReminderId);
        if (warrantyRemindStore.detailRemindRespone.isSuccess) {
          getDataMateGroup(undefined, warrantyRemindStore.detailRemindRespone.data?.nhomVatTuList.length ? warrantyRemindStore.detailRemindRespone.data?.nhomVatTuList : undefined);
          getMateClass(undefined, warrantyRemindStore.detailRemindRespone.data?.phanLoaiVatTuList.length ? warrantyRemindStore.detailRemindRespone.data?.phanLoaiVatTuList : undefined);


          setListProduct(warrantyRemindStore.detailRemindRespone.data?.productList || [])
          // form.setFieldValue('productList', warrantyRemindStore.detailRemindRespone.data?.productList || [])
          tableRef.current?.reload()


          setSelectedRowKeys(
            warrantyRemindStore.detailRemindRespone.data?.productList.map(item => item.stt) || []
          )
          setListProductId(warrantyRemindStore.detailRemindRespone.data?.productList.map(item => item.productId) || [])

          const tempt = { ...warrantyRemindStore.detailRemindRespone.data }
          form.setFieldsValue(tempt);
        } else {
          message.error(warrantyRemindStore.detailRemindRespone.message);
        }
      } else {
        getDataMateGroup();
        getMateClass();
      }
    }

    useEffect(() => {
      (() => {
        getDataCompany();
        getDetailData();
      })()
    }, [])


    const handleFinish = async (value: any) => {
      setLoading({ btn: true })
      if (warrantyReminderId) {
        const tempt = { ...value }
        const newVal = Object.fromEntries(Object.entries(tempt).filter(([_, val]) => {
          if (Array.isArray(val) && val.length > 0) return true
          if (typeof val === 'string' && val) return true
          if (typeof val === 'boolean') return true
          if (typeof val === 'number') return true
          return false
        }))

        await warrantyRemindPresenter.editWarrantyRemind(warrantyRemindStore,
          { ...newVal, isRepeat: true, remindConfigId: warrantyReminderId, productList: listProductId, remindConfigType: 'RC3' })
      } else {
        await warrantyRemindPresenter.createWarrantyRemind(warrantyRemindStore,
          {
            ...value,
            isRepeat: true,
            productList: listProductId,
            remindConfigType: 'RC3'
          }
        )
      }
      if (warrantyRemindStore.createRemindRespone.isSuccess) {
        message.success(warrantyRemindStore.createRemindRespone.message)
        if (isContinue) {
        } else {
          navigate(ROUTES.MASTER_DATA.WARRANTY_REMINDER.LINK)
        }
      }
      setLoading({ btn: false })
    }


    const initialValue = {
      isRepeat: true,
      actived: true,
      config: 'RC1',
      companyCode: getPlantCode()
    }

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t("page-title.warranty-reminder"),
            to: ROUTES.MASTER_DATA.WARRANTY_REMINDER.LINK,
          },
          {
            text: pageTitle,
          },
        ]}
        extras={
          <>{
            warrantyReminderId ?
              <CustomButton
                loading={loading.btn}
                onClick={showModal}
                type="primary"
              >
                Cập nhật lịch nhắc cho phiếu ĐKBH đã tạo
              </CustomButton> : <></>
          }
            <CustomButton
              loading={loading.btn}
              onClick={(e) => {
                form.submit();
                setContinue(false);
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              loading={loading.btn}
              onClick={() => {
                form.submit();
                setContinue(true);
              }}
              type="primary"
              icon={<Download className="!fill-white" />}
            >
              Lưu và tiếp tục
            </CustomButton>
          </>
        }
      >

        {/* Table */}
        <BoxContainer>
          <SearchForm
            form={form}
            layout="horizontal"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            labelAlign="right"
            column="col-2"
            onFinish={(value: any) => {
              handleFinish(value)
            }}
            initialValues={warrantyReminderId ? {
              config: 'RC1',
            } : initialValue}
          >
            {/* -------------------------left-------------------------- */}
            <div className="col-span-1 flex flex-col gap-y-2">
              {/* Công ty */}
              <SearchItem
                name={"companyCode"}
                label={t("search-form.company")}
                rules={[
                  { required: true, message: 'Vui lòng chọn' }
                ]}
              >
                <CustomSelect
                  disabled={!!warrantyReminderId}
                  options={listCompany}
                  fieldNames={{ label: "value", value: "key" }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </SearchItem>

              {/* Phân loại vật tư */}
              <SearchItem
                name={"phanLoaiVatTuList"}
                label={t("search-form.material-class")}
              // rules={[
              //   { required: remindConfigType === 'RC1', message: 'Vui lòng chọn' }
              // ]}
              >
                <CustomSelect
                  allowClear
                  options={listMateClass}
                  mode='multiple'
                  fieldNames={{ label: "value", value: "key" }}
                  showSearch
                  onChange={(value) => {
                    value && getDataSanPham()
                  }}
                  filterOption={false}
                  onSearch={(value) => value ? debounceSearchMateClass(value) : debounceSearchMateClass()}
                  onClear={() => debounceSearchMateClass()}

                />
              </SearchItem>
              {/* Nhóm vật tư */}
              <SearchItem
                name={"nhomVatTuList"}
                label={t("search-form.material-group")}
              // rules={[
              //   { required: remindConfigType === 'RC2', message: 'Vui lòng chọn' }
              // ]}
              >
                <CustomSelect
                  allowClear mode='multiple'
                  options={listMateGroup}
                  fieldNames={{ label: "value", value: "key" }}
                  showSearch
                  onChange={(value) => {
                    value && getDataSanPham()
                  }}
                  filterOption={false}
                  onSearch={(value) => value ? debounceSearchMateGroup(value) : debounceSearchMateGroup()}
                  onClear={() => debounceSearchMateGroup()}
                />
              </SearchItem>
            </div>
            {/* ------------------------right--------------------------- */}
            <div className="col-span-1 flex flex-col gap-y-2">
              {/* Thời gian khả dụng */}
              <SearchItem
                name={"monthAvailable"}
                label={t("search-form.available-time")}
                rules={[
                  { required: true, message: 'Vui lòng chọn' }
                ]}
              >
                <InputNumber addonAfter="Tháng" />
              </SearchItem>
              {/* Tần suất lặp lại */}
              <SearchItem
                rules={[
                  { required: true, message: 'Vui lòng chọn' }
                ]}
                name={"frequency"}
                label={t("search-form.frequency")}
              >
                <InputNumber
                  // disabled={isRepeat ? false : true}
                  addonAfter="Tháng/lần" />
              </SearchItem>
              {/* Trạng thái */}
              <SearchItem
                name={"actived"}
                label={t("zalo-notification.status")}
              >
                <Radio.Group>
                  <Radio value={true}>Đang sử dụng</Radio>
                  <Radio value={false}>Ngưng sử dụng</Radio>
                </Radio.Group>
              </SearchItem>
            </div>

            <div className="col-span-2 flex justify-center items-center my-5">
              <CustomButton
                loading={loading.searchProduct}
                onClick={async () => {
                  setLoading({ searchProduct: true })
                  await getDataSanPham()
                  tableRef.current?.reload()
                  setLoading({ searchProduct: false })
                }}
                type='primary'
              >
                Lấy dữ liệu
              </CustomButton>
            </div>
          </SearchForm>
        </BoxContainer>

        <BoxContainer>
          <CustomProTable
            columns={defaultColumn}
            size="small"
            name={'productList'}
            // dataSource={listProduct}
            options={false}
            actionRef={tableRef}
            key={'productId'}
            request={async (params, sort, filter) => {
              const data = cloneDeep(listProduct)
              const datafilter = data.filter(item => {
                return normalizeString(item.productName?.toLowerCase())?.includes(normalizeString(params.productName?.toLowerCase() || '')) &&
                  normalizeString(item.productCode?.toLowerCase())?.includes(normalizeString(params.productCode?.toLowerCase()) || '') &&
                  normalizeString(item.sapCode?.toLowerCase())?.includes(normalizeString(params.sapCode?.toLowerCase()) || '')
              })
              // console.log({
              //   datafilter,params
              // });
              return {
                data: datafilter,
                success: true
              }
            }}
            search={{
              labelWidth: 'auto',
              resetText: "Reset",
            }}

            tableAlertRender={false}
            scroll={{
              y: 310
            }}
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectChange,
            }}
            rowKey="stt"
          />
        </BoxContainer>

        <Modal
          title="Chọn thời gian tạo phiếu ĐKBH"
          open={open}
          className="min-w-[80%] w-full [&_.ant-modal-content]:!p-2"
          okButtonProps={{
            hidden: true
          }}
          onCancel={handleClose}
          cancelButtonProps={{
            hidden: true
          }}
        >
          <ReminderModal warrantyReminderId={warrantyReminderId} productIds={listProductId} handleClose={handleClose} companyCode={form.getFieldValue('companyCode')} />
        </Modal>
      </PageWrapper >
    )
  })
}

export default createAddUpdate